import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Pages } from 'modules/navigation/domain/enums/pages';
import PlayerForm, { SubmitPlayerForm } from 'modules/players/ui/components/player-form';
import { TeamPlayer } from 'modules/teams/domain/interfaces/team-player';
import { useCreateTeamPlayer } from 'modules/teams/ui/hooks/use-create-team-player';

interface CreatePlayerProps {
  tournamentId: number;
  teamId: number;
  /** Весь состав команды — и заведённые вручную игроки, и вступившие участники. */
  players: TeamPlayer[];
}

const CreatePlayer = (props: CreatePlayerProps) => {
  const navigate = useNavigate();

  const { tournamentId, teamId, players } = props;
  const playerId = Number(useLocation().state?.fromPlayer);

  const handleDisableForm = useCallback(() => {
    navigate(Pages.TEAMS.builders.edit(teamId, 'players'), {
      state: { fromPlayer: playerId },
    });
  }, [navigate, playerId, teamId]);

  const { createPlayer, isLoading } = useCreateTeamPlayer({
    tournamentId,
    teamId,
    players,
    onCreated: handleDisableForm,
  });

  const handleSubmit = useCallback<SubmitPlayerForm>(
    async ({ values, formikHelpers }) => {
      try {
        await createPlayer(values);
      } finally {
        formikHelpers.setSubmitting(false);
      }
    },
    [createPlayer],
  );

  return (
    <div className="pt-6">
      <PlayerForm onSubmit={handleSubmit} isLoading={isLoading} />
    </div>
  );
};

export default CreatePlayer;
